import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    data(vm) {
        return {
            commentInputClass: { input: "w-35" } as { input: string; textarea?: string }
        };
    },

    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "application"])
    },
    methods: {
        resultUpdatedAppended(value: string) {
            this.patientDetails.demographics.faceSheetComments += value;
        },
        resultUpdated(value: string) {
            this.patientDetails.demographics.faceSheetComments = value;
        }
    }
});
